/**
 * Multilingual speakable answers for voice search in 7 languages.
 * Each page gets its own set of answers targeting tourist search queries
 * in English, French, German, Italian, Dutch, Spanish, and Romanian.
 */

// Key business phrases translated for speakable voice search
export const multilingualSpeakable = {
  // FRENCH
  fr: {
    home: [
      "Brunchi.shop est un magasin de vins, spiritueux et bières artisanales avec terrasse bar à Marina Rubicon, Playa Blanca, Lanzarote.",
      "Dégustation de vin du lundi au samedi — 4 verres de vin volcanique de Lanzarote pour 14 euros. Sans réservation.",
      "Plus de 800 spiritueux, cigares cubains Cohiba et Montecristo.",
      "Ouvert du lundi au samedi de 10h à 15h et de 18h à 22h, fermé le dimanche. Commandez par e-mail : consultas@brunchi.shop."
    ],
    wines: [
      "Meilleur magasin de vins à Playa Blanca. Vins volcaniques de Lanzarote : Yaiza, El Grifo, Bermejo.",
      "Dégustation de vin : 4 verres pour 14 euros sur notre terrasse à Marina Rubicon. Du lundi au samedi, sans réservation.",
      "Vins au verre à partir de 6 euros."
    ],
    spirits: [
      "Plus de 800 spiritueux : whisky, gin, rhum, vodka, tequila. Cigares cubains Cohiba et Montecristo.",
      "Dégustation de whisky : 3 mesures premium pour 29 euros. Rhum Miel des Canaries à partir de 12,50 euros."
    ],
    hospitality: [
      "Terrasse bar à Marina Rubicon. Dégustation de vin 14 euros, sangria à partir de 18 euros, Aperol Spritz 8,50 euros.",
      "Glaces artisanales, boissons sans alcool, familial. Vue sur la marina."
    ],
    yaiza: [
      "Vin Yaiza de Lanzarote — les célèbres bouteilles bleues. Malvasía Volcánica Seco, Afrutado, Rosado à partir de 21,50 euros.",
      "Acheter du vin Yaiza à Playa Blanca chez Brunchi.shop, Marina Rubicon. Au verre dès 6 euros. Dégustation 4 verres 14 euros."
    ],
    "el-grifo": [
      "Vin El Grifo — la plus ancienne bodega des Canaries, fondée en 1775. Malvasía Seco, Colección, Moscatel à partir de 18,50 euros.",
      "Acheter du vin El Grifo à Playa Blanca chez Brunchi.shop. Dégustation au verre dès 6 euros à Marina Rubicon."
    ],
    bermejo: [
      "Vin Bermejo — vin bio de Lanzarote. Los Bermejos, Malvasía Volcánica Ecológico, Naturalmente Dulce à partir de 19,50 euros.",
      "Acheter du vin Bermejo bio à Playa Blanca chez Brunchi.shop. Au verre dès 6 euros. Marina Rubicon."
    ],
    nao: [
      "Bière artisanale NAO de Lanzarote. Lanzarote Lager, Mucho IPA, Marinera Blonde Ale à partir de 5,00 euros.",
      "Acheter de la bière NAO à Playa Blanca chez Brunchi.shop, Marina Rubicon. Sur la terrasse ou à emporter."
    ],
    malpeis: [
      "Bière artisanale Malpeis de Lanzarote. La Fresca IPA, Rofe Bock, Bermeja Red IPA à partir de 5,00 euros.",
      "Acheter de la bière Malpeis à Playa Blanca chez Brunchi.shop, Marina Rubicon. Sur la terrasse ou à emporter."
    ]
  },
  // GERMAN
  de: {
    home: [
      "Brunchi.shop ist ein Wein-, Spirituosen- und Craft-Bier-Laden mit Terrassenbar in Marina Rubicon, Playa Blanca, Lanzarote.",
      "Weinverkostung Montag bis Samstag — 4 Gläser Lanzarote Vulkanwein für 14 Euro. Keine Reservierung erforderlich.",
      "Über 800 Spirituosen, kubanische Zigarren Cohiba und Montecristo.",
      "Geöffnet Montag bis Samstag 10-15 Uhr und 18-22 Uhr, sonntags geschlossen. Bestellen per E-Mail: consultas@brunchi.shop."
    ],
    wines: [
      "Bester Weinladen in Playa Blanca. Vulkanweine von Lanzarote: Yaiza, El Grifo, Bermejo.",
      "Weinverkostung: 4 Gläser für 14 Euro auf unserer Terrasse in Marina Rubicon. Montag bis Samstag ohne Reservierung.",
      "Wein glasweise ab 6 Euro."
    ],
    spirits: [
      "Über 800 Spirituosen: Whisky, Gin, Rum, Wodka, Tequila. Kubanische Zigarren Cohiba und Montecristo.",
      "Whisky-Verkostung: 3 Premium-Gläser für 29 Euro. Kanarischer Honigrum Ron Miel ab 12,50 Euro."
    ],
    hospitality: [
      "Terrassenbar in Marina Rubicon. Weinverkostung 14 Euro, Sangria ab 18 Euro, Aperol Spritz 8,50 Euro.",
      "Handgemachtes Eis, alkoholfreie Getränke, familienfreundlich. Blick auf den Yachthafen."
    ],
    yaiza: [
      "Yaiza Wein — die berühmten blauen Flaschen von Lanzarote. Malvasía Volcánica Seco, Afrutado, Rosado ab 21,50 Euro.",
      "Yaiza Wein in Playa Blanca kaufen bei Brunchi.shop, Marina Rubicon. Glasweise ab 6 Euro."
    ],
    "el-grifo": [
      "El Grifo — älteste Bodega der Kanarischen Inseln, gegründet 1775. Malvasía Seco, Colección ab 18,50 Euro.",
      "El Grifo Wein in Playa Blanca kaufen bei Brunchi.shop, Marina Rubicon."
    ],
    bermejo: [
      "Bermejo Bio-Wein aus Lanzarote. Malvasía Volcánica Ecológico ab 19,50 Euro. Naturalmente Dulce Solera.",
      "Bermejo Wein in Playa Blanca kaufen bei Brunchi.shop, Marina Rubicon."
    ],
    nao: [
      "NAO Craft-Bier aus Lanzarote. Lanzarote Lager, Mucho IPA, Marinera Blonde Ale ab 5,00 Euro.",
      "NAO Bier in Playa Blanca kaufen bei Brunchi.shop, Marina Rubicon. Auf der Terrasse oder zum Mitnehmen."
    ],
    malpeis: [
      "Malpeis Craft-Bier aus Lanzarote. La Fresca IPA, Rofe Bock, Bermeja Red IPA ab 5,00 Euro.",
      "Malpeis Bier in Playa Blanca kaufen bei Brunchi.shop, Marina Rubicon. Auf der Terrasse oder zum Mitnehmen."
    ]
  },
  // ITALIAN
  it: {
    home: [
      "Brunchi.shop è un negozio di vini, liquori e birre artigianali con terrazza bar a Marina Rubicon, Playa Blanca, Lanzarote.",
      "Degustazione vini dal lunedì al sabato — 4 bicchieri di vino vulcanico di Lanzarote per 14 euro. Senza prenotazione.",
      "Oltre 800 liquori, sigari cubani Cohiba e Montecristo.",
      "Aperto lunedì-sabato 10-15 e 18-22, domenica chiuso. Ordina via e-mail: consultas@brunchi.shop."
    ],
    wines: [
      "Miglior enoteca a Playa Blanca. Vini vulcanici di Lanzarote: Yaiza, El Grifo, Bermejo.",
      "Degustazione vini: 4 bicchieri per 14 euro sulla nostra terrazza a Marina Rubicon. Dal lunedì al sabato senza prenotazione."
    ],
    spirits: [
      "Oltre 800 liquori: whisky, gin, rum, vodka, tequila. Sigari cubani Cohiba e Montecristo.",
      "Degustazione whisky: 3 misure premium per 29 euro. Ron Miel delle Canarie da 12,50 euro."
    ],
    hospitality: [
      "Terrazza bar a Marina Rubicon. Degustazione vini 14 euro, sangria da 18 euro, gelato artigianale.",
      "Bevande analcoliche disponibili. Ambiente familiare con vista sulla marina."
    ],
    yaiza: [
      "Vino Yaiza — le famose bottiglie blu di Lanzarote. Malvasía Volcánica Seco, Afrutado, Rosado da 21,50 euro.",
      "Comprare vino Yaiza a Playa Blanca da Brunchi.shop, Marina Rubicon. Al bicchiere da 6 euro."
    ],
    "el-grifo": [
      "Vino El Grifo — la bodega più antica delle Canarie, fondata nel 1775. Malvasía Seco, Colección da 18,50 euro.",
      "Comprare vino El Grifo a Playa Blanca da Brunchi.shop, Marina Rubicon."
    ],
    bermejo: [
      "Vino biologico Bermejo di Lanzarote. Malvasía Volcánica Ecológico da 19,50 euro. Naturalmente Dulce solera.",
      "Comprare vino Bermejo biologico a Playa Blanca da Brunchi.shop, Marina Rubicon."
    ],
    nao: [
      "Birra artigianale NAO di Lanzarote. Lanzarote Lager, Mucho IPA, Marinera Blonde Ale da 5,00 euro.",
      "Comprare birra NAO a Playa Blanca da Brunchi.shop, Marina Rubicon. In terrazza o da asporto."
    ],
    malpeis: [
      "Birra artigianale Malpeis di Lanzarote. La Fresca IPA, Rofe Bock, Bermeja Red IPA da 5,00 euro.",
      "Comprare birra Malpeis a Playa Blanca da Brunchi.shop, Marina Rubicon. In terrazza o da asporto."
    ]
  },
  // DUTCH
  nl: {
    home: [
      "Brunchi.shop is een wijn-, sterkedrank- en ambachtelijke bierwinkel met terrasbar in Marina Rubicon, Playa Blanca, Lanzarote.",
      "Dagelijkse wijnproeverij — 4 glazen Lanzarote vulkaanwijn voor 14 euro. Geen reservering nodig.",
      "Meer dan 800 sterkedranken, Cubaanse sigaren Cohiba en Montecristo.",
      "Open maandag-zaterdag 10-15 uur en 18-22 uur, zondag gesloten. Bestel via e-mail: consultas@brunchi.shop."
    ],
    wines: [
      "Beste wijnwinkel in Playa Blanca. Vulkaanwijnen van Lanzarote: Yaiza, El Grifo, Bermejo.",
      "Wijnproeverij: 4 glazen voor 14 euro op ons terras in Marina Rubicon. Maandag t/m zaterdag zonder reservering."
    ],
    spirits: [
      "Meer dan 800 sterkedranken: whisky, gin, rum, wodka, tequila. Cubaanse sigaren Cohiba en Montecristo.",
      "Whiskyproeverij: 3 premium glazen voor 29 euro. Kanarische honingrum Ron Miel vanaf 12,50 euro."
    ],
    hospitality: [
      "Terrasbar in Marina Rubicon. Wijnproeverij 14 euro, sangria vanaf 18 euro.",
      "Ambachtelijk ijs, alcoholvrije dranken. Gezinsvriendelijk met uitzicht op de jachthaven."
    ],
    yaiza: [
      "Yaiza wijn — de beroemde blauwe flessen uit Lanzarote. Malvasía Volcánica Seco, Afrutado, Rosado vanaf 21,50 euro.",
      "Yaiza wijn kopen in Playa Blanca bij Brunchi.shop, Marina Rubicon. Per glas vanaf 6 euro."
    ],
    "el-grifo": [
      "El Grifo wijn — oudste bodega van de Canarische Eilanden, opgericht in 1775. Malvasía Seco, Colección vanaf 18,50 euro.",
      "El Grifo wijn kopen in Playa Blanca bij Brunchi.shop, Marina Rubicon."
    ],
    bermejo: [
      "Bermejo biologische wijn uit Lanzarote. Malvasía Volcánica Ecológico vanaf 19,50 euro. Naturalmente Dulce solera.",
      "Bermejo wijn kopen in Playa Blanca bij Brunchi.shop, Marina Rubicon."
    ],
    nao: [
      "NAO ambachtelijk bier uit Lanzarote. Lanzarote Lager, Mucho IPA, Marinera Blonde Ale vanaf 5,00 euro.",
      "NAO bier kopen in Playa Blanca bij Brunchi.shop, Marina Rubicon. Op het terras of om mee te nemen."
    ],
    malpeis: [
      "Malpeis ambachtelijk bier uit Lanzarote. La Fresca IPA, Rofe Bock, Bermeja Red IPA vanaf 5,00 euro.",
      "Malpeis bier kopen in Playa Blanca bij Brunchi.shop, Marina Rubicon. Op het terras of om mee te nemen."
    ]
  },
  // SPANISH
  es: {
    home: [
      "Brunchi.shop es una tienda de vinos, licores y cervezas artesanales con terraza bar en Marina Rubicón, Playa Blanca, Lanzarote.",
      "Cata de vinos de lunes a sábado — 4 copas de vino volcánico de Lanzarote por 14 euros. Sin reserva.",
      "Más de 800 licores, puros cubanos Cohiba y Montecristo.",
      "Abierto lunes a sábado 10-15h y 18-22h, domingo cerrado. Pedidos por email: consultas@brunchi.shop."
    ],
    wines: [
      "La mejor tienda de vinos en Playa Blanca. Vinos volcánicos de Lanzarote: Yaiza, El Grifo, Bermejo.",
      "Cata de vinos: 4 copas por 14 euros en nuestra terraza en Marina Rubicón. De lunes a sábado sin reserva.",
      "Vino por copa desde 6 euros."
    ],
    spirits: [
      "Más de 800 licores: whisky, ginebra, ron, vodka, tequila. Puros cubanos Cohiba y Montecristo.",
      "Cata de whisky: 3 medidas premium por 29 euros. Ron Miel canario desde 12,50 euros."
    ],
    hospitality: [
      "Terraza bar en Marina Rubicón. Cata de vinos 14 euros, sangría desde 18 euros, Aperol Spritz 8,50 euros.",
      "Helados artesanales, bebidas sin alcohol, apto para familias. Vistas a la marina."
    ],
    yaiza: [
      "Vino Yaiza — las famosas botellas azules de Lanzarote. Malvasía Volcánica Seco, Afrutado, Rosado desde 21,50 euros.",
      "Comprar vino Yaiza en Playa Blanca en Brunchi.shop, Marina Rubicón. Por copa desde 6 euros."
    ],
    "el-grifo": [
      "Vino El Grifo — la bodega más antigua de Canarias, fundada en 1775. Malvasía Seco, Colección desde 18,50 euros.",
      "Comprar vino El Grifo en Playa Blanca en Brunchi.shop, Marina Rubicón."
    ],
    bermejo: [
      "Vino ecológico Bermejo de Lanzarote. Malvasía Volcánica Ecológico desde 19,50 euros. Naturalmente Dulce solera.",
      "Comprar vino Bermejo ecológico en Playa Blanca en Brunchi.shop, Marina Rubicón."
    ],
    nao: [
      "Cerveza artesanal NAO de Lanzarote. Lanzarote Lager, Mucho IPA, Marinera Blonde Ale desde 5,00 euros.",
      "Comprar cerveza NAO en Playa Blanca en Brunchi.shop, Marina Rubicón. En la terraza o para llevar."
    ],
    malpeis: [
      "Cerveza artesanal Malpeis de Lanzarote. La Fresca IPA, Rofe Bock, Bermeja Red IPA desde 5,00 euros.",
      "Comprar cerveza Malpeis en Playa Blanca en Brunchi.shop, Marina Rubicón. En la terraza o para llevar."
    ]
  },
  // ROMANIAN
  ro: {
    home: [
      "Brunchi.shop este un magazin de vinuri, băuturi spirtoase și bere artizanală cu terasă bar în Marina Rubicon, Playa Blanca, Lanzarote.",
      "Degustare de vinuri în fiecare zi — 4 pahare de vin vulcanic din Lanzarote pentru 14 euro. Fără rezervare.",
      "Peste 800 de băuturi spirtoase, trabucuri cubaneze Cohiba și Montecristo.",
      "Deschis luni-sâmbătă 10-15 și 18-22, duminică închis. Comenzi pe e-mail: consultas@brunchi.shop."
    ],
    wines: [
      "Cel mai bun magazin de vinuri din Playa Blanca. Vinuri vulcanice din Lanzarote: Yaiza, El Grifo, Bermejo.",
      "Degustare de vin: 4 pahare pentru 14 euro pe terasa noastră din Marina Rubicon. De luni până sâmbătă fără rezervare."
    ],
    spirits: [
      "Peste 800 de băuturi spirtoase: whisky, gin, rom, vodcă, tequila. Trabucuri cubaneze Cohiba și Montecristo.",
      "Degustare whisky: 3 măsuri premium pentru 29 euro. Ron Miel din Canare de la 12,50 euro."
    ],
    hospitality: [
      "Terasă bar în Marina Rubicon. Degustare vin 14 euro, sangria de la 18 euro.",
      "Înghețată artizanală, băuturi nealcoolice. Prietenos pentru familii cu vedere la port."
    ],
    yaiza: [
      "Vin Yaiza — celebrele sticle albastre din Lanzarote. Malvasía Volcánica Seco, Afrutado, Rosado de la 21,50 euro.",
      "Cumpără vin Yaiza în Playa Blanca la Brunchi.shop, Marina Rubicon. La pahar de la 6 euro."
    ],
    "el-grifo": [
      "Vin El Grifo — cea mai veche bodega din Canare, fondată în 1775. Malvasía Seco, Colección de la 18,50 euro.",
      "Cumpără vin El Grifo în Playa Blanca la Brunchi.shop, Marina Rubicon."
    ],
    bermejo: [
      "Vin ecologic Bermejo din Lanzarote. Malvasía Volcánica Ecológico de la 19,50 euro. Naturalmente Dulce solera.",
      "Cumpără vin Bermejo ecologic în Playa Blanca la Brunchi.shop, Marina Rubicon."
    ],
    nao: [
      "Bere artizanală NAO din Lanzarote. Lanzarote Lager, Mucho IPA, Marinera Blonde Ale de la 5,00 euro.",
      "Cumpără bere NAO în Playa Blanca la Brunchi.shop, Marina Rubicon. Pe terasă sau la pachet."
    ],
    malpeis: [
      "Bere artizanală Malpeis din Lanzarote. La Fresca IPA, Rofe Bock, Bermeja Red IPA de la 5,00 euro.",
      "Cumpără bere Malpeis în Playa Blanca la Brunchi.shop, Marina Rubicon. Pe terasă sau la pachet."
    ]
  }
};

/**
 * Build multilingual FAQ schemas for a given page context.
 * Returns array of JSON-LD FAQPage schemas, one per language.
 */
export const buildMultilingualFaqSchemas = (pageKey) => {
  const topQuestions = {
    home: {
      fr: [
        { q: "Où acheter du vin à Playa Blanca ?", a: "Brunchi.shop à Marina Rubicon propose plus de 100 vins de Lanzarote et du monde. Dégustation 4 verres pour 14€. Ouvert du lundi au samedi." },
        { q: "Où acheter des cigares cubains à Playa Blanca ?", a: "Brunchi.shop vend des cigares cubains Cohiba, Montecristo et Romeo y Julieta dans un humidor climatisé à Marina Rubicon." },
        { q: "Que faire à Playa Blanca le soir ?", a: "Brunchi.shop offre dégustations de vin, flights de whisky, sangria et bière artisanale sur la terrasse de Marina Rubicon jusqu'à 22h." }
      ],
      de: [
        { q: "Wo kann man in Playa Blanca Wein kaufen?", a: "Brunchi.shop in Marina Rubicon bietet über 100 Weine aus Lanzarote und der Welt. Weinverkostung 4 Gläser für 14€. Montag bis Samstag geöffnet." },
        { q: "Wo kann man in Playa Blanca kubanische Zigarren kaufen?", a: "Brunchi.shop verkauft kubanische Zigarren Cohiba, Montecristo und Romeo y Julieta aus einem klimatisierten Humidor." },
        { q: "Was kann man abends in Playa Blanca machen?", a: "Brunchi.shop bietet Weinverkostung, Whisky-Flights, Sangria und Craft-Bier auf der Terrasse in Marina Rubicon bis 22 Uhr." }
      ],
      it: [
        { q: "Dove comprare vino a Playa Blanca?", a: "Brunchi.shop a Marina Rubicon offre più di 100 vini di Lanzarote e del mondo. Degustazione 4 bicchieri per 14€. Aperto dal lunedì al sabato." },
        { q: "Dove comprare sigari cubani a Playa Blanca?", a: "Brunchi.shop vende sigari cubani Cohiba, Montecristo e Romeo y Julieta conservati in un humidor climatizzato." },
        { q: "Cosa fare la sera a Playa Blanca?", a: "Brunchi.shop offre degustazioni di vino, whisky, sangria e birra artigianale sulla terrazza di Marina Rubicon fino alle 22." }
      ],
      nl: [
        { q: "Waar kan ik wijn kopen in Playa Blanca?", a: "Brunchi.shop in Marina Rubicon heeft meer dan 100 wijnen uit Lanzarote en de wereld. Wijnproeverij 4 glazen voor 14€. Maandag t/m zaterdag geopend." },
        { q: "Waar kan ik Cubaanse sigaren kopen in Playa Blanca?", a: "Brunchi.shop verkoopt Cubaanse sigaren Cohiba, Montecristo en Romeo y Julieta uit een geklimatiseerde humidor." },
        { q: "Wat te doen 's avonds in Playa Blanca?", a: "Brunchi.shop biedt wijnproeverijen, whiskyflights, sangria en ambachtelijk bier op het terras in Marina Rubicon tot 22 uur." }
      ],
      es: [
        { q: "¿Dónde comprar vino en Playa Blanca?", a: "Brunchi.shop en Marina Rubicón ofrece más de 100 vinos de Lanzarote y del mundo. Cata 4 copas por 14€. Abierto de lunes a sábado." },
        { q: "¿Dónde comprar puros cubanos en Playa Blanca?", a: "Brunchi.shop vende puros cubanos Cohiba, Montecristo y Romeo y Julieta en un humidor climatizado en Marina Rubicón." },
        { q: "¿Qué hacer por la noche en Playa Blanca?", a: "Brunchi.shop ofrece catas de vino, flights de whisky, sangría y cerveza artesanal en la terraza de Marina Rubicón hasta las 22h." }
      ],
      ro: [
        { q: "Unde pot cumpăra vin în Playa Blanca?", a: "Brunchi.shop în Marina Rubicon oferă peste 100 vinuri din Lanzarote. Degustare 4 pahare pentru 14€. Deschis de luni până sâmbătă." },
        { q: "Unde pot cumpăra trabucuri cubaneze în Playa Blanca?", a: "Brunchi.shop vinde trabucuri cubaneze Cohiba, Montecristo și Romeo y Julieta dintr-un humidor climatizat." },
        { q: "Ce poți face seara în Playa Blanca?", a: "Brunchi.shop oferă degustări de vin, whisky, sangria și bere artizanală pe terasa din Marina Rubicon până la 22." }
      ]
    }
  };

  const questions = topQuestions[pageKey] || topQuestions.home;
  const schemas = [];

  for (const [lang, faqs] of Object.entries(questions)) {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "inLanguage": lang,
      "mainEntity": faqs.map(f => ({
        "@type": "Question",
        "name": f.q,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": f.a
        }
      }))
    });
  }

  return schemas;
};
